var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.networkError)?_c('div',{staticClass:"mask",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.stop($event)}}},[_c('div',{staticClass:"title"},[_vm._v("\n    当前网络已断开，请检查该设备的网络环境！\n  ")]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":_vm.wldk,"alt":""}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b692cfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublicAssembly/networkErrorMask.vue
// module id = null
// module chunks = 